import {Grid, Stack} from '@mui/material';
import React from 'react';
import {FieldsRendererProps} from '.';
import {AppControlledEditor} from 'components/form/AppTextEditor';

interface RenderTextEditorProps extends FieldsRendererProps {
    gridSize?: number;
    boardId?: string;
}
export const RenderTextEditor: React.FC<RenderTextEditorProps> = ({
    field,
    control,
    boardId,
    baseFieldName,
    gridSize,
}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledEditor
                    label={field.title}
                    scopeId={boardId}
                    required={field.isRequired}
                    placeholder={field.placeHolder}
                    control={control}
                    name={`${baseFieldName}.value`}
                />
            </Stack>
        </Grid>
    );
};

export default RenderTextEditor;
